import React, { useState, useEffect } from 'react';

import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';

const Footer = () => {

    useEffect(() => {
        const script = document.createElement('script');

        script.src = "https://platform.linkedin.com/badges/js/profile.js";
        script.async = "text/javascript";

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);

    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const { username, email, message } = formData;

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    };

    const handleSubmit = () => {
        setLoading(true);

        const contact = {
            _type: 'contact',
            name: formData.username,
            email: formData.email,
            message: formData.message,
        };

        client.create(contact)
            .then(() => {
                setLoading(false);
                setIsFormSubmitted(true);
            })
    };

    const Mailto = ({ email, subject = '', body = '', children }) => {
        let params = subject || body ? '?' : '';
        if (subject) params += `subject=${encodeURIComponent(subject)}`;
        if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

        return <a href={`mailto:edelfino@umich.edu${params}`}>{children}</a>;
    };


    return (
        <>
            <h2 className="head-text">Take a Coffee & chat with me</h2>
            <div className="app__footer-cards">
                <div className="badge-base LI-profile-badge" data-locale="en_US" data-size="large" data-theme="light" data-type="HORIZONTAL" data-vanity="erika-delfino" data-version="v1"><a class="badge-base__link LI-simple-link" href="https://www.linkedin.com/in/erika-delfino?trk=profile-badge"></a></div>
                <div className="app__contacts">
                    <div className="app__footer-card">
                        <img src={images.email} alt="email" />
                        <Mailto className="p-text" email="Mail Me!" subject="Hello Erika!" body="Contact me!">
                            Mail me!
                        </Mailto>
                    </div>
                    <div className="app__footer-card">
                        <img src={images.git} alt="mobile" />
                        <a href="https://github.com/edelfino11">My github!</a>
                    </div>
                </div>
            </div>
            {!isFormSubmitted ?
                <div className="app__footer-form app__flex">
                    <div className="app__flex">
                        <input className="p-text" type="text" placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} />
                    </div>
                    <div className="app__flex">
                        <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
                    </div>
                    <div>
                        <textarea
                            className="p-text"
                            placeholder="Your Message"
                            value={message}
                            name="message"
                            onChange={handleChangeInput}
                        />
                    </div>
                    <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
                </div>
                : <div>
                    <h3 className="head-text">Thank you for getting in touch!</h3>
                </div>
            }
        </>
    );
}

export default AppWrap(
    MotionWrap(Footer, 'app__footer'),
    'contact',
    'app__whitebg'
);